import React, { CSSProperties, useMemo } from 'react';
import classnames from 'classnames';
import CloseIcon from './icons/close.svg';
import PlusIcon from './icons/plus.svg';
import PlusSmallIcon from './icons/plus-small.svg';
import MinusIcon from './icons/minus.svg';
import LinkIcon from './icons/link.svg';
import RightArrowIcon from './icons/right-arrow.svg';
import LeftArrowIcon from './icons/left-arrow.svg';
import UpArrowIcon from './icons/up-angled-bracket.svg';
import DownArrowIcon from './icons/down-arrow.svg';
import DownloadIcon from './icons/download.svg';
import CheckIcon from './icons/check.svg';
import VolumeIcon from './icons/volume.svg';
import MuteIcon from './icons/mute.svg';
import PauseBubbleIcon from './icons/pause-bubble.svg';
import PlayBubbleIcon from './icons/play-bubble.svg';
import SearchIcon from './icons/search.svg';
import PlayIcon from './icons/play.svg';
import FindLocationIcon from './icons/find-location.svg';
import ContactIcon from './icons/contact.svg';
import StorePinIcon from './icons/store-pin.svg';
import ARIcon from './icons/ar.svg';
import BackspaceIcon from './icons/backspace.svg';
import PreviewIcon from './icons/preview.svg';
import GalleryIcon from './icons/gallery.svg';
import HamburgerMenuIcon from './icons/hamburger-menu.svg';
import FullscreenIcon from './icons/fullscreen.svg';
import CloseFullscreenIcon from './icons/close-fullscreen.svg';
import WkLogoIcon from './icons/wk-logo.svg';
import WkGMapsBrandSpaceIcon from './icons/wk-gmaps-brandspace.svg';
import WkGMapsStoreIcon from './icons/wk-gmaps-store.svg';
import CircleIcon from './icons/circle.svg';
import SortIcon from './icons/sort.svg';
import DetailsIcon from './icons/details.svg';
import FacebookIcon from './icons/facebook.svg';
import InstagramIcon from './icons/instagram.svg';
import YoutubeIcon from './icons/youtube.svg';
import PinterestIcon from './icons/pinterest2.svg';
import LinkedinIcon from './icons/linkedin.svg';
import classes from './Icon.module.scss';

export type IconImageType = React.ComponentType<{ className: string }>;

export const IconImage = {
  Close: CloseIcon,
  Plus: PlusIcon,
  PlusSmall: PlusSmallIcon,
  Minus: MinusIcon,
  Link: LinkIcon,
  RightArrow: RightArrowIcon,
  LeftArrow: LeftArrowIcon,
  UpArrow: UpArrowIcon,
  DownArrow: DownArrowIcon,
  Download: DownloadIcon,
  Check: CheckIcon,
  Volume: VolumeIcon,
  Mute: MuteIcon,
  PauseBubble: PauseBubbleIcon,
  PlayBubble: PlayBubbleIcon,
  Search: SearchIcon,
  Play: PlayIcon,
  FindLocation: FindLocationIcon,
  StorePin: StorePinIcon,
  Contact: ContactIcon,
  AR: ARIcon,
  Backspace: BackspaceIcon,
  Preview: PreviewIcon,
  Gallery: GalleryIcon,
  HamburgerMenu: HamburgerMenuIcon,
  Fullscreen: FullscreenIcon,
  CloseFullscreen: CloseFullscreenIcon,
  Sort: SortIcon,
  WkLogo: WkLogoIcon,
  WkGMapsBrandSpace: WkGMapsBrandSpaceIcon,
  WkGMapsStore: WkGMapsStoreIcon,
  Circle: CircleIcon,
  Details: DetailsIcon,
  Facebook: FacebookIcon,
  Instagram: InstagramIcon,
  Youtube: YoutubeIcon,
  Pinterest: PinterestIcon,
  Linkedin: LinkedinIcon,
};

export interface IconProps {
  image: IconImageType;
  className?: string;
  size?: 'normal' | 'fluid' | 'custom';
  style?: CSSProperties;
  onClick?: () => void;
  rotation?: number;
}

export const Icon: React.FunctionComponent<IconProps> = ({
  image: SVG,
  size = 'normal',
  className,
  style,
  onClick,
  rotation = 0,
  ...restProps
}: IconProps) => {
  const cn = useMemo(
    () => classnames(classes.icon, className, size !== 'custom' ? classes[size] : null),
    [className, size]
  );

  const usedStyle = { ...style };

  if (rotation) {
    usedStyle.transform = (usedStyle.transform || '').concat(` rotate(${rotation}deg)`);
  }
  return (
    <div className={cn} style={usedStyle} onClick={onClick} {...restProps}>
      <SVG className={classes.svg} />
    </div>
  );
};

export default Icon;
